import { api } from "@/services/api";
import type { User } from "@/types/user";

export function userService() {
	return {
		/** GET /api/v3/user/ — dados do usuário autenticado */
		async getProfile(): Promise<User> {
			const { data } = await api.get<User>("/user/");
			return data;
		},

		/** PATCH /api/v3/user/ — atualizar perfil */
		async updateProfile(payload: Partial<User>): Promise<User> {
			const { data } = await api.patch<User>("/user/", payload);
			return data;
		},

		/** PATCH /api/v3/preferences/ — atualizar preferências (tema, background, nickname, avatar) */
		async updatePreferences(payload: {
			color_mode_theme?: number;
			background?: number;
			nickname?: string;
			avatar?: Blob | File;
		}): Promise<void> {
			const { avatar, ...rest } = payload;
			if (!avatar) {
				await api.patch("/preferences/", rest);
				return;
			}

			const formData = new FormData();
			for (const [key, value] of Object.entries(rest)) {
				if (value !== undefined) {
					formData.append(key, String(value));
				}
			}
			const filename = avatar instanceof File ? avatar.name : "avatar.jpg";
			formData.append("avatar", avatar, filename);

			await api.patch("/preferences/", formData, {
				headers: { "Content-Type": "multipart/form-data" },
			});
		},

		/** PATCH /api/v3/mood/ — atualizar humor */
		async updateMood(mood: number): Promise<void> {
			await api.patch("/mood/", { mood });
		},

		/** POST /api/v3/password/change/ — troca senha do aluno autenticado */
		async changePassword(payload: {
			old_password: string;
			new_password1: string;
			new_password2: string;
		}): Promise<void> {
			await api.post("/password/change/", payload);
		},
	};
}
